import { urlBase } from "./config";
import axiosInstance from "./config/axiosinstance";

export async function getAllSpeakers(
  eventId,
  offset,
  limit,
  search,
  columnSearch = ""
) {
  try {
    const config = {
      method: "get",
      url: `${urlBase}/palestrantes/${eventId}/event/?offset=${offset}&limit=${limit}&search=${search}&columnSearch=${columnSearch}`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    const response = await axiosInstance(config);
    return response;
  } catch (error) {
    return error.response;
  }
}

export async function createSpeaker(data) {
  var config = {
    method: "post",
    url: `${urlBase}/palestrantes`,
    headers: {
      "Content-Type": "application/json",
    },
    data,
  };

  return axiosInstance(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function updateSpeaker(data, id) {
  var config = {
    method: "put",
    url: `${urlBase}/palestrantes/${id}`,
    headers: {
      "Content-Type": "application/json",
    },
    data,
  };

  return axiosInstance(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function deleteSpeaker(id) {
  var config = {
    method: "delete",
    url: `${urlBase}/palestrantes/${id}`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axiosInstance(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function deleteAllSpeaker(eventId) {
  var config = {
    method: "delete",
    url: `${urlBase}/palestrantes/${eventId}/event`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axiosInstance(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}
